import { useState } from 'react';
import I18n from '../../config/i18n';
import { Row, Col } from '../../utils/grid/Grid';
import Toggle from '../../utils/Toggle';
import Logo from './logo/Logo';
import Langswitch from './langswitch/Langswitch';
import MainNav from './nav/MainNav';
import IdSearch from './id-search/IdSearch';
import ContactIconSwitch from './contactIconSwitch/ContactIconSwitch';
import ContactHotline from '../features/contact/ContactHotline';

import './header.css';

interface HeaderProps {
  // eslint-disable-next-line camelcase
  is_special: boolean;
  // eslint-disable-next-line camelcase
  is_admin: boolean;
  // eslint-disable-next-line camelcase
  is_translator: boolean;
  // eslint-disable-next-line camelcase
  is_agency_member: boolean;
  // eslint-disable-next-line camelcase
  is_host: boolean;
}

function AdminUser(): JSX.Element {
  return (
    <>
      <a href={`/${I18n.locale}/administration`} className="super-user-links-item">
        {I18n.t('web_app_theme.administration')}
      </a>
      <a href="/console" className="super-user-links-item">
        {I18n.t('web_app_theme.console')}
      </a>
    </>
  );
}

function TranslatorUser(): JSX.Element {
  return (
    <a href={`/${I18n.locale}/translate`} className="super-user-links-item">
      {I18n.t('web_app_theme.translate')}
    </a>
  );
}

function AgencyUser(): JSX.Element {
  return (
    <a href={`/${I18n.locale}/agency`} className="super-user-links-item">
      {I18n.t('web_app_theme.agency')}
    </a>
  );
}

function SuperUserLinks(user: HeaderProps): JSX.Element | null {
  if (!user.is_special) {
    return null;
  }
  return (
    <div className="super-user-links">
      {user.is_admin ? <AdminUser /> : null}
      {user.is_translator ? <TranslatorUser /> : null}
      {user.is_agency_member ? <AgencyUser /> : null}
    </div>
  );
}

export default function Header(props: HeaderProps): JSX.Element {
  const [showContactHeader, setShowContactHeader] = useState(false);

  function toggleContactHeader() {
    setShowContactHeader(!showContactHeader);
  }

  return (
    <div className="header-container" id="content-header">
      <header className="header">
        <Row between="xs" className="header-row">
          <Col xs={5} md={3} className="header-logo">
            <Logo />
          </Col>
          <Col xs={7} md={9} className="header-nav">
            <Toggle hide="xs sm">
              <Row className="header-nav-secondary">
                <Col>
                  <SuperUserLinks {...props} />
                </Col>
                <Col md className="header-col-langswitch">
                  <Langswitch />
                </Col>
                <Col md>
                  <ContactHotline />
                </Col>
              </Row>
            </Toggle>
            <Row middle="xs" className="header-nav-primary">
              <Col xs>
                <Toggle show="xs sm">
                  <div className="header-container__contact-icon-switch-wrapper">
                    <ContactIconSwitch toggleContactHeader={toggleContactHeader} />
                  </div>
                </Toggle>
                <MainNav {...props} />
                <Toggle hide="xs sm">
                  <span className="header-container__id-search">
                    <IdSearch />
                  </span>
                </Toggle>
              </Col>
            </Row>
          </Col>
        </Row>
        <Toggle show="xs sm">{showContactHeader ? <ContactHotline /> : null}</Toggle>
      </header>
    </div>
  );
}
